"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeedsPerChannel = void 0;
const tslib_1 = require("tslib");
const helpers_1 = require("../helpers");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const axiosUtil_1 = require("../utils/axiosUtil");
const getFeedsPerChannel = options => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    user,
    env = constants_1.default.ENV.PROD,
    page = constants_1.default.PAGINATION.INITIAL_PAGE,
    limit = constants_1.default.PAGINATION.LIMIT,
    spam = false,
    raw = false,
    channels = []
  } = options || {};
  const _user = yield (0, helpers_1.getCAIPAddress)(env, user, 'User');
  const API_BASE_URL = (0, helpers_1.getAPIBaseUrls)(env);
  if (channels.length == 0) {
    throw new Error('channels cannot be empty');
  }
  const _channel = yield (0, helpers_1.getCAIPAddress)(env, channels[0], 'Channel');
  const apiEndpoint = "".concat(API_BASE_URL, "/v1/users/").concat(_user, "/channels/").concat(_channel, "/feeds");
  const queryObj = {
    page,
    limit: (0, helpers_1.getLimit)(limit),
    spam
  };
  const requestUrl = "".concat(apiEndpoint, "?").concat((0, helpers_1.getQueryParams)(queryObj));
  return (0, axiosUtil_1.axiosGet)(requestUrl).then(response => {
    var _a, _b;
    if (raw) {
      return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.feeds) || [];
    }
    return (0, utils_1.parseApiResponse)((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.feeds) || [];
  }).catch(err => {
    console.error("[Push SDK] - API ".concat(requestUrl, ": "), err);
  });
});
exports.getFeedsPerChannel = getFeedsPerChannel;
//# sourceMappingURL=getFeedsPerChannel.js.map